module.exports = __webpack_public_path__ + "static/display-78310bea5029b1207a2871930020a16f.png";